import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InvoicePreviewModal = ({ isOpen, invoice, onClose, onDownload, onSendEmail }) => {
  if (!isOpen || !invoice) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-3xl bg-card rounded-xl elevation-2xl overflow-hidden border border-border max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-heading font-semibold text-foreground flex items-center gap-2">
              <Icon name="FileText" size={24} className="text-primary" />
              Invoice Preview
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-md transition-smooth"
              aria-label="Close modal"
            >
              <Icon name="X" size={20} className="text-muted-foreground" />
            </button>
          </div>

          {/* Invoice Content */}
          <div className="bg-background border border-border rounded-lg p-6 md:p-8 mb-6">
            <div className="flex items-start justify-between mb-8">
              <div>
                <h3 className="text-2xl font-bold text-foreground">INVOICE</h3>
                <p className="text-sm text-muted-foreground mt-1">{invoice?.invoiceNumber}</p>
              </div>
              <div className="text-right">
                <p className="text-sm text-muted-foreground">Date</p>
                <p className="text-base font-semibold text-foreground">{new Date(invoice?.date)?.toLocaleDateString()}</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div>
                <p className="text-xs text-muted-foreground uppercase mb-2">Bill To</p>
                <p className="text-base font-semibold text-foreground">{invoice?.clientName}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground uppercase mb-2">Plan</p>
                <p className="text-base font-semibold text-foreground">{invoice?.plan}</p>
              </div>
            </div>

            <div className="border-t border-border pt-6">
              <div className="flex items-center justify-between mb-4">
                <p className="text-sm text-muted-foreground">Subscription Amount</p>
                <p className="text-base font-semibold text-foreground">₹{invoice?.amount?.toLocaleString()}</p>
              </div>
              <div className="flex items-center justify-between pt-4 border-t border-border">
                <p className="text-lg font-bold text-foreground">Total Amount</p>
                <p className="text-2xl font-bold text-foreground">₹{invoice?.amount?.toLocaleString()}</p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Close
            </Button>
            <Button
              variant="default"
              size="lg"
              onClick={() => onDownload(invoice)}
              iconName="Download"
              iconPosition="left"
              fullWidth
            >
              Download PDF
            </Button>
            <Button
              variant="secondary"
              size="lg"
              onClick={() => onSendEmail(invoice)}
              iconName="Mail"
              iconPosition="left"
              fullWidth
            >
              Send Email
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreviewModal;